<template> 
  <div>
    <p class="legend">Para suscribirte al plan necesitamos vincular una tarjeta de crédito o débito.</p>
    <div id="cardPaymentBrick_container"></div> 
  </div> 
</template>

<script>
import axios from "axios";

export default { 
  name: "cardFormMp",
  data(){
    return {
      mpLink: '',
      mpMail: '',
      tokenCardmp: '',
      printErr: ''
    }
  },

  beforeUnmount() {
    try {
      window.paymentBrickController.unmount()
    } catch(e) {}
  },

  async mounted() {
    let publicKey = (window.location.host.includes('animasana.net')) 
      ? 'APP_USR-aaff932b-be75-449a-9dce-e0e443cce5c9' 
      : 'APP_USR-cce3f21c-1c96-476f-a112-ba657a1198b7';

    // Cargar SDK si no está
    if (!window.MercadoPago) {
      await new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = 'https://sdk.mercadopago.com/js/v2';
        script.async = false;
        script.onload = resolve;
        document.head.appendChild(script);
      });
    }

    // Inicializar MercadoPago con antifraude activo
    const mp = new MercadoPago(publicKey, {
      locale: 'es-AR'
    });

    const bricksBuilder = mp.bricks();

    const settings = {
      initialization: {
        amount: 2999,
      },
      customization: {
        paymentMethods: {
          //ticket: "all",
          creditCard: "all",
          debitCard: "all",
          //mercadoPago: "all",
          maxInstallments: 1,
        },
        visual: {
          hideFormTitle: false,
          texts: { formSubmit: "Vincular" },
          style: { theme: 'bootstrap' },
        },
      },
      /*settings: {
        showCvv: true,
        showInstallments: true,
        showIssuer: true,
      },*/
      callbacks: {
        onReady: () => {
          console.log('Brick listo');
        },
        onSubmit: async (formData) => {
        // callback llamado al hacer clic en el botón de envío de datos
            console.log("formData completo:", formData);
            this.tokenCardmp = formData.token;
            this.mpMail = formData.payer.email;
            console.log('mpMail:', this.mpMail);
            console.log('tokenCardmp:', this.tokenCardmp);
            this.createLink();
        },
        onError: (error) => {
          console.error(error);
        },
      },
    };

    window.paymentBrickController = await bricksBuilder.create(
      "cardPayment",
      "cardPaymentBrick_container",
      settings
    );
  },

  methods: {
    async createLink() {
      const payload = {
        action: 'link-plan-suscription-mp',
        browserCountry: this.$route.params.browserCountry,
        userLang: this.$route.params.userLang,
        urlcode: window.location.host,
        dataReceiver: localStorage.getItem('token'),
        back: window.location.href,
        userMail: this.mpMail,
        cardTokenId: this.tokenCardmp,
        deviceId: MP_DEVICE_SESSION_ID
      };
      console.log('Payload enviado:', payload);

      try {
        const result = await axios.post('/index.php', payload);
        console.log('Respuesta backend:', result);

        window.paymentBrickController.unmount();

        if (result.data.status === '200') {
          this.mpLink = result.data.link;
          this.$router.push({ name: 'plan-status', params: { ref: 'success' } });
        } else {
          this.$router.push({ name: 'plan-status', params: { ref: 'rejected', ref2: result.data.sms } });
        }
      } catch (error) {
        console.error('Error al crear link:', error);
      }
    }
  }
}
</script>
<style scoped>
.pricing-table .pricing-box-2.sm-pricing-box .price-legend {
    max-width: 100%;
    margin: auto;
    margin-bottom: 20px;
    color: #000;
    font-size: 15px;
    color: #5798ef;
}
.btn-primary, button.btn.btn-primary {
    background-color: #0d6efd !important;
    border-color: #0d6efd !important;
    border-radius: initial !important;
    text-decoration: none;
    text-align: center;
}
.btn-primary:hover, .btn-primary:focus {
    color: #fff;
    background-color: #1a52b1 !important;
    border-color: #1a52b1 !important;
    background: #1a52b1 !important;
}
.w-fit-content{
    width: fit-content;
}
</style>
